// CORE-1735 slice 8 — one `matchMedia` per query for the whole room (the
// reduced-motion / reduced-transparency hooks used to subscribe per instance).
import { useEffect, useState } from 'react';
import { WEB } from './useLiveTheme';

const lists = new Map<string, MediaQueryList>();

function listFor(query: string): MediaQueryList | null {
  if (!WEB || typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  let mq = lists.get(query);
  if (!mq) { mq = window.matchMedia(query); lists.set(query, mq); }
  return mq;
}

export function mediaMatches(query: string): boolean {
  return !!listFor(query)?.matches;
}

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => mediaMatches(query));
  useEffect(() => {
    const mq = listFor(query);
    if (!mq) return;
    const onChange = () => setMatches(mq.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, [query]);
  return matches;
}
